<div class="login-root">
  <canvas #neuralCanvas class="neural-canvas" aria-hidden="true"></canvas>

  <div class="auth-card">
    <!-- Left Panel: Branding -->
    <div class="auth-card__brand">
      <img src="./assets/img/logohorizontalpng/logo1.png" alt="Solser" class="brand-logo" />
      <span class="brand-tag">Information Technology</span>
      <h1 class="brand-title">Bienvenido a Solser</h1>
      <p class="brand-subtitle">Centro Operativo</p>
    </div>

    <!-- Right Panel: Login Form -->
    <div class="auth-card__form">
      <div class="login-header">
        <h2>Iniciar Sesión</h2>
        <p>Ingresa tus credenciales para continuar</p>
      </div>

      <form (ngSubmit)="onSignin(f)" #f="ngForm" class="login-form">
        <div class="field">
          <label class="field__label" for="usuario">Usuario</label>
          <div class="field__control">
            <i class="material-icons field__icon">person</i>
            <input
              #usuario
              type="text"
              id="usuario"
              name="usuario"
              [(ngModel)]="usuarioValor"
              placeholder="Usuario..."
              maxlength="100"
              autocomplete="username"
              required>
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="password">Contraseña</label>
          <div class="field__control">
            <i class="material-icons field__icon">lock_outline</i>
            <input
              #password
              [type]="mostrarPassword ? 'text' : 'password'"
              id="password"
              name="password"
              [(ngModel)]="passwordValor"
              placeholder="Contraseña..."
              maxlength="20"
              autocomplete="current-password"
              required>
            <button
              type="button"
              class="field__toggle"
              (click)="mostrarPassword = !mostrarPassword"
              [attr.aria-label]="mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <i class="material-icons">{{ mostrarPassword ? 'visibility_off' : 'visibility' }}</i>
            </button>
          </div>
        </div>

        <!-- Va como standalone a propósito: así no entra en f.value y lo que el
             formulario entrega al ingresar queda exactamente igual que antes. -->
        <label class="recordar">
          <input
            type="checkbox"
            class="recordar__input"
            [(ngModel)]="recordar"
            [ngModelOptions]="{ standalone: true }"
            (change)="alternarRecordar()">
          <span class="recordar__caja" aria-hidden="true">
            <i class="material-icons">check</i>
          </span>
          <span class="recordar__txt">Recordar</span>
        </label>

        <button class="btn-login" type="submit" [disabled]="!f.valid">
          Ingresar
          <i class="material-icons">east</i>
        </button>

        <a class="forgot-password" (click)="recuperarPass()">¿Olvidaste tu contraseña?</a>
      </form>

      <footer class="auth-footer">
        <!-- Sin el año: ya lo dice el © de al lado y salía dos veces. -->
        {{ fechahoy | date: "EEEE, d 'de' MMMM" }} ·
        <a href="https://www.solsersistem.net" target="_blank">
          Solser | Information Technology &copy; {{ fechahoy | date : "y" }}
        </a>
      </footer>
    </div>
  </div>
</div>
